import { render, staticRenderFns } from "./DragUploader.vue?vue&type=template&id=48797340&scoped=true"
import script from "./DragUploader.vue?vue&type=script&lang=js"
export * from "./DragUploader.vue?vue&type=script&lang=js"
import style0 from "./DragUploader.vue?vue&type=style&index=0&id=48797340&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48797340",
  null
  
)

export default component.exports